import { render, staticRenderFns } from "./OrdinationArrow.vue?vue&type=template&id=94630d6c&"
import script from "./OrdinationArrow.vue?vue&type=script&lang=js&"
export * from "./OrdinationArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports